module.exports = __webpack_public_path__ + "static/img/product_images_big28_h5_zh.b13c58c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_big28_h5_zh.png
// module id = yn7Z
// module chunks = 34